import React from 'react';
import { BrandMark } from '../ui/Brand';

/**
 * Közös váz a belépés / regisztráció / jelszó / e-mail oldalakhoz — a jóváhagyott
 * sablon „window” ablaka (login.html, register.html …, 2026-10-04).
 *
 * Középre zárt, 440 px széles ablak: fent a márka és egy gépírós címke (`bar`), benne a
 * cím, az alcím és a tartalom 18 px-es közökkel, alul opcionális lábsor (`footer`: pl.
 * „No account yet?” + link — két gyerek, a két szélre igazítva).
 * `result`: az eredmény-képernyők (megerősítve, lejárt link) ikonja; ilyenkor a cím középre kerül.
 */
export default function AuthShell({ bar, title, subtitle, result, children, footer, wide = false }) {
  return (
    <div className="wrap pt-12 sm:pt-[72px] pb-20 sm:pb-28 flex justify-center">
      <div className={`window w-full ${wide ? 'max-w-[520px]' : 'max-w-[440px]'}`}>
        <div className="window-bar">
          <BrandMark size={24} />
          {bar && <span className="font-mono text-[11px] text-gray-600">{bar}</span>}
        </div>

        <div className="p-5 sm:p-6 flex flex-col gap-[18px]">
          {result}
          <div className={result ? 'text-center' : ''}>
            <h1 className="text-2xl font-semibold tracking-[-0.025em] text-gray-50">{title}</h1>
            {subtitle && <p className="mt-1 text-sm text-gray-500">{subtitle}</p>}
          </div>
          {children}
        </div>

        {footer && (
          <div className="px-5 sm:px-6 py-3.5 border-t border-line-faint flex items-center justify-between gap-3 text-[13px] text-gray-500">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}

/** Mező: felirat + bevitel + opcionális segédszöveg (a sablon `.field`-je). */
export function Field({ label, htmlFor, aside, hint, children }) {
  return (
    <div className="flex flex-col">
      <div className="flex items-baseline justify-between gap-3">
        <label htmlFor={htmlFor} className="label">{label}</label>
        {aside}
      </div>
      {children}
      {hint && <p className="mt-[7px] text-xs text-gray-500">{hint}</p>}
    </div>
  );
}

/** Beágyazott mellék-űrlap (pl. új megerősítő link kérése) a fő űrlap fölött. */
export function SubForm({ onSubmit, children }) {
  return (
    <form onSubmit={onSubmit} className="p-4 flex flex-col gap-3 rounded-panel bg-bar border border-line">
      {children}
    </form>
  );
}
